import { render, staticRenderFns } from "./Success.vue?vue&type=template&id=53b782ef&scoped=true&"
var script = {}
import style0 from "./Success.vue?vue&type=style&index=0&id=53b782ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b782ef",
  null
  
)

export default component.exports